import { PlaybackControlBar, TOOLBAR_HEIGHT } from '@/components/canvas/designer/toolbars/PlaybackToolbar';

export interface PlaybackLayerProps {
  isFullscreen: boolean;
  playbackBarVisible: boolean;
  onPlaybackBarVisibleChange: (visible: boolean) => void;
  currentPageIndex: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
  autoPlay: boolean;
  onAutoPlayChange: (value: boolean) => void;
  loop: boolean;
  onLoopChange: (value: boolean) => void;
  playbackIntervalSeconds: number;
  onPlaybackIntervalChange: (seconds: number) => void;
  onExitComponent?: () => void;
}

export function PlaybackLayer({
  isFullscreen,
  playbackBarVisible,
  onPlaybackBarVisibleChange,
  currentPageIndex,
  totalPages,
  onPrev,
  onNext,
  autoPlay,
  onAutoPlayChange,
  loop,
  onLoopChange,
  playbackIntervalSeconds,
  onPlaybackIntervalChange,
  onExitComponent,
}: PlaybackLayerProps) {
  if (!isFullscreen) return null;

  return (
    <div
      className="absolute bottom-0 left-0 right-0 z-20"
      style={{ height: TOOLBAR_HEIGHT }}
      onMouseEnter={() => onPlaybackBarVisibleChange(true)}
      onMouseLeave={() => onPlaybackBarVisibleChange(false)}
      aria-hidden={!playbackBarVisible}
    >
      {playbackBarVisible ? (
        <PlaybackControlBar
          currentPage={currentPageIndex}
          totalPages={totalPages}
          onPrev={onPrev}
          onNext={onNext}
          autoPlay={autoPlay}
          onAutoPlayChange={onAutoPlayChange}
          loop={loop}
          onLoopChange={onLoopChange}
          playbackIntervalSeconds={playbackIntervalSeconds}
          onPlaybackIntervalChange={onPlaybackIntervalChange}
          onExitFullscreen={() => document.fullscreenElement && document.exitFullscreen()}
          onExitComponent={onExitComponent}
        />
      ) : null}
    </div>
  );
}
